import { ReactElement } from 'react';
import ExerciseTagManagement from '../../../components/exerciseTag/ExerciseTagManagement';

const SuperAdminExerciseTags = (): ReactElement => {
  return (
    <ExerciseTagManagement mode="superAdmin" />
  )
}

export default SuperAdminExerciseTags